import { render } from "./CreateMedicationDialog.vue?vue&type=template&id=2a2c76ba"
import script from "./CreateMedicationDialog.vue?vue&type=script&lang=js"
export * from "./CreateMedicationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__